export const FORM_LABELS = [
  "FIRST_NAME",
  "LAST_NAME",
  "EMAIL",
  "COMPANY_NAME",
  "COMPANY_WEBSITE",
  "PHONE",
  "REQUIREMENTS",
  "PROJECTS",
  "EVENTS",
  "OPERATIONS",
  "RENTALS",
  "OTHER",
  "DETAILS",
  "SUBMIT",
  "COUNTRY",
] as const
export type FormLabelsKeys = typeof FORM_LABELS[number]

export const FORM_PLACEHOLDERS = [
  "FIRST_NAME_PLACEHOLDER",
  "LAST_NAME_PLACEHOLDER",
  "EMAIL_PLACEHOLDER",
  "PHONE_PLACEHOLDER",
  "COMPANY_PLACEHOLDER",
  "COMPANY_WEBSITE_PLACEHOLDER",
  "REQUIREMENT_PLACEHOLDER",
  "DETAILS_PLACEHOLDER",
] as const
export type FormPlaceholderKeys = typeof FORM_PLACEHOLDERS[number]

export const FORM_ERRORS = ["REQUIRED", "INVALID_EMAIL"] as const
export type FormErrorsKeys = typeof FORM_ERRORS[number]

export type MessageKey =
  | "KEY_WITH_PARAMS"
  | "TITLE"
  | "SERVICES"
  | "LEARN_MORE"
  | "REQUEST_OFFER"
  | "WHAT_WE_DO"
  | "CONTACT"
  | "CONTACT_US"
  | "PERSONAL_DATA"
  | "TOPIC"
  | "THANK_YOU_MESSAGE"
  | "EXPLORE"
  | "SCROLL_DOWN"
  | "FOLLOW_US"
  | "PRIVACY"
  | "YOUR_QUESTION"
  | "HOME"
  | FormLabelsKeys
  | FormErrorsKeys
  | FormPlaceholderKeys

type MessagesWithProps = {
  KEY_WITH_PARAMS: {
    exampleParam: string
  }
}

export type Messages = Record<MessageKey, string>

export type I18NMessage = {
  [T in MessageKey]: T extends keyof MessagesWithProps
    ? { key: T; params: MessagesWithProps[T] }
    : T
}[MessageKey]
